export default __webpack_public_path__ + "static/media/1882.801dd9b8.png";